// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/Counter.js with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Counter, Notifications as NotificationsIcon } from '@sail/ui';
import { deprecatedCss, view } from '@sail/engine';
const basic = {
  rendered: <>
      <Counter>4</Counter>

      <Counter type="emphasized">12</Counter>

      <view.div uses={[deprecatedCss`
      position: relative;
      display: flex;
      align-items: center;
      padding: 0 4px;
    `]}>
        <NotificationsIcon />
        <Counter type="micro" uses={[deprecatedCss`
        position: absolute;
        top: 0;
        right: 0;
      `]} />
      </view.div>
    </>,
  source: `<Counter>4</Counter>
<Counter type="emphasized">12</Counter>
<Counter type="micro" />`
};
export const CounterExamples = {
  basic
};